import { useCallback, useMemo, useState } from 'react'
import _data from 'common/utils/_data'
import Project from 'common/project'

import throttle from 'lodash/throttle'

const SEARCH_DELAY = 500

export const useDocumentLibrary = () => {
  const [search, setSearch] = useState<string>('')
  const [documentLibrary, setDocumentLibrary] = useState<any>([])
  const [isFeedbackProcessing, setFeedbackProcessing] = useState<boolean>(false)

  const throttledSetTitle = useCallback(
    throttle(setSearch, SEARCH_DELAY, { leading: true }),
    [],
  )

  const updateDocumentLibrarySearchValue = useCallback(
    (text: string) => {
      setSearch(text)
      throttledSetTitle(text)
    },
    [throttledSetTitle],
  )

  const loadDocumentLibrary = useCallback(() => {
    if (search.trim().length > 3) {
      fetch(
        `https://jeb18bftn0.execute-api.eu-west-2.amazonaws.com/dev/predict`,
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ query: search }),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          const bodyData =
            typeof data.body === 'string' ? JSON.parse(data.body) : data.body

          setDocumentLibrary((prev) => {
            const exists = prev.some(
              (doc) => doc.document_id === bodyData.document_id,
            )
            return exists ? prev : [...prev, bodyData]
          })
        })
        .catch((err) => {
          console.error('Error fetching document prediction:', err)
        })
    }
  }, [search])

  type FeedbackSource = 'home_page' | 'law_finder' | 'document_dictionary'

  interface FeedbackPayload {
    feedback: string
    rating: number
    uploaded_file?: File
    source: FeedbackSource
  }
  const submitFeedBack = useCallback(async (payload: FeedbackPayload) => {
    setFeedbackProcessing(true)
    try {
      await _data.post(`${Project.liveApi}website-user-feedback/add/`, payload)
    } catch (error) {
      console.error('submitFeedBack error:', error)
      throw new Error(
        `Error in submitFeedBack: ${error?.message ?? 'Unknown error'}`,
      )
    } finally {
      setFeedbackProcessing(false)
    }
  }, [])

  const results = useMemo(() => {
    return documentLibrary?.predicted_document !== '' ? documentLibrary : null
  }, [search, documentLibrary])

  return {
    loadDocumentLibrary,
    documentLibrary: results,
    updateDocumentLibrarySearchValue,
    search,
    isFeedbackProcessing,
    submitFeedBack,
  }
}
